import { MyJobsClosedPeriod } from "_enums/enums";

// My Jobs view helpers - see docs/features/my-jobs-filtering.md.

const CLOSED_PERIODS = Object.values(MyJobsClosedPeriod);

/**
 * The Filters panel's "Closed jobs" period is picked: the list is closed jobs
 * from the archive API (/tickets/archived/all) and the stage buttons don't apply.
 */
export const isClosedJobsView = (filters) => CLOSED_PERIODS.includes(filters?.closedPeriod);

/**
 * My Jobs filters for an entry point (dashboard tile or chart, property card):
 * a clean slate on Repairs, All, with the given overrides. Users switch pillar
 * to see the same drill-down in Compliance.
 *
 * @param {Object} overrides - e.g. { stage }, { status }, { closedPeriod }, { property }
 */
export const myJobsEntryFilters = (overrides = {}) => ({
  status: "",
  property: "",
  tradesPerson: "",
  landlord: "",
  primaryContact: "",
  jobType: "",
  stage: "",
  closedPeriod: "",
  complianceRunId: "",
  openOnly: false,
  ...overrides
});
